export default "__VITE_ASSET__ClPIcnOM__"